const BOOKING_STAGE = Object.freeze([
    {
        hash: '#collection',
        name: 'collection',
        label: 'Collection',
        sugarAPIStages: [
            'Pre-Booking',
            'Awaiting Collection',
            'Pet Collected',
            'With Contractor',
            'At Transport / Holding Facility'
        ]
    },
    {
        hash: '#confirmation',
        name: 'confirmation',
        label: 'Confirmation',
        sugarAPIStages: [
            'Awaiting Keepsakes',
            'On Hold'
        ]
    },
    {
        hash: '#keepsakes',
        name: 'keepsakes',
        label: 'Keepsakes',
        sugarAPIStages: [
            'Awaiting Cremation'
        ]
    },
    {
        hash: '#cremation',
        name: 'cremation',
        label: 'Cremation',
        sugarAPIStages: [
            'In Cremation'
        ]
    },
    {
        hash: '#memorialisation',
        name: 'memorialisation',
        label: 'Memorialisation',
        sugarAPIStages: [
            'Awaiting Processing',
            'Ashes Processed',
            'Ashes in Library (On Hold)'
        ]
    },
    {
        hash: '#inspection',
        name: 'inspection',
        label: 'Inspection',
        sugarAPIStages: [
            'Preparation Completed'
        ]
    },
    {
        hash: '#return',
        name: 'return',
        label: 'Return',
        sugarAPIStages: [
            'Quality Assurance Completed',
            'Split Delivery - Awaiting Return',
            'Split Delivery - Returned',
            'Split Delivery - Ready at Office',
            'Split Delivery - Posted',
            'Split Delivery - Awaiting Product',
            'Awaiting Return Delivery',
            'Ready at Office (Awaiting Completion)'
        ]
    },
    {
        hash: '#completed',
        name: 'Completed',
        label: 'Completed',
        sugarAPIStages: [
            'Completed - Returned',
            'Completed - Posted'
        ]
    }
]);

export default BOOKING_STAGE;
